import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    cyear: number = new Date().getFullYear();
  constructor(public userUtilsService:UserUtilService) { }

  ngOnInit(): void {
  }

}
